window.addShippingWeight = async function (e) {
  e.preventDefault();

  // These variables are the most likely to change
  const weightBreakpointPounds = 42;
  const shippingWeightVariantId = 43306335371311;
  // Cow share product IDs. We should consider changing this to work off a tag or metafield
  const exemptProductIds = [ 8144432234543, 8144426958895, 8108796117039, 8158467260463, 8158467555375, 8158467522607, 8158467489839, 8158467457071, 8158467391535, 8158467325999, 8158467293231, 8158467260463, 8153935609903, 8153935577135, 8153935544367, 8153935511599, 8153935478831, 8153935446063, 7850858250287, 8182711386159, 8084034748463, 44593864507439, 44593864540207];

  const gramsPerPound = 453.592;
  const weightBreakpointGrams = weightBreakpointPounds * gramsPerPound;

  const cart = await fetch(window.Shopify.routes.root + "cart.js").then(
    (response) => response.json()
  );

  const totalGrams = cart.items
    .filter(
      ({ variant_id, properties, product_id }) =>
        variant_id !== shippingWeightVariantId &&
        !properties?._isPresetBundleProduct &&
        !exemptProductIds.includes(product_id)
    )
    .reduce((sum, { grams, quantity }) => sum + (grams || 0) * quantity, 0);

  const shippingWeightProductsNeeded = Math.ceil(
    totalGrams / weightBreakpointGrams
  );

  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      updates: { [shippingWeightVariantId]: shippingWeightProductsNeeded },
    }),
  })
    .catch(console.error)
    .then(() => {
      window.location = "/checkout";
    });
};
